import {
  Component,
  OnInit,
  Injectable,
  EventEmitter
} from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd
} from '@angular/router';

import { filter, map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ThemeServiceService {
  public currentService: EventEmitter<string>;

  public setCurrentService() {
    this.router
    .events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => {
      let child = this.route.firstChild;
      while (child) {
        if (child.firstChild) {
          child = child.firstChild;
        } else if (child.snapshot.data && child.snapshot.data['service']) {
          return child.snapshot.data['service'];
        } else {
          return null;
        }
      }
      return null;
    })).subscribe( (customData: any) => {
      if (customData == null || customData == undefined) {
        customData = "autopartage"
      }
      this.currentService.emit(customData);
      // conserror(customData);
   });
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    this.currentService = new EventEmitter();
    this.router
    .events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => {
      let child = this.route.firstChild;
      while (child) {
        if (child.firstChild) {
          child = child.firstChild;
        } else if (child.snapshot.data && child.snapshot.data['service']) {
          return child.snapshot.data['service'];
        } else {
          return null;
        }
      }
      return null;
    })).subscribe( (customData: any) => {
      if (customData == null || customData == undefined) {
        customData = "autopartage"
      }
      this.currentService.emit(customData);
      // conserror(customData);
   });
  }
}
